import classifiesAsMultipleOuts from "../../classificators/outType/classifiesAsMultipleOuts.js";
import classifiesAsBatterOut from "../../classificators/plateAppearanceResult/classifiesAsBatterOut.js";
import classifiesAsStrikeout from "../../classificators/plateAppearanceResult/classifiesAsStrikeout.js";
import sessionCouldHaveNewScoringData from "../../classificators/sessionContents/sessionCouldHaveNewScoringData.js";
import DataSection from "../../enums/DataSection.js";
import Out from "../../enums/Out.js";
import OutType from "../../enums/OutType.js";
import ResultDataNew from "../../enums/ResultDataNew.js";
import ScoringData from "../../enums/ScoringData.js";
import ContextualFilterBase from "./ContextualFilterBase.js";

/**
 * Filters out double and triple plays
 * @see https://www.mlb.com/glossary/standard-stats/double-play
 * @see https://www.mlb.com/glossary/standard-stats/triple-play
 */
class ClassifiedAsMultipleOutsFilter extends ContextualFilterBase {
    constructor(multipleOutsClassifier, strikeoutClassifier, batterOutClassifier) {
        if (typeof(multipleOutsClassifier) !== 'undefined' && typeof(multipleOutsClassifier) !== 'function') {
            throw new TypeError('multipleOutsClassifier must be undefined or an predicate taking single argument - out type');
        }
        if (typeof(strikeoutClassifier) !== 'undefined' && typeof(strikeoutClassifier) !== 'function') {
            throw new TypeError('strikeoutClassifier must be undefined or an predicate taking single argument - pa result');
        }
        if (typeof(batterOutClassifier) !== 'undefined' && typeof(batterOutClassifier) !== 'function') {
            throw new TypeError('batterOutClassifier must be undefined or an predicate taking single argument - pa result');
        }

        super();

        this.multipleOutsClassifier = multipleOutsClassifier || classifiesAsMultipleOuts;
        this.strikeoutClassifier = strikeoutClassifier || classifiesAsStrikeout;
        this.batterOutClassifier = batterOutClassifier || classifiesAsBatterOut;
    }

    filter(results, session, league) {
        // games with new scoring goes here
        if (sessionCouldHaveNewScoringData(
            session.parameters.SessionContents, session.parameters.SessionSchemaRef
        )) {
            // for new scoring look for specific pitch call and PA result values...
            const multiOutsActions = [];

            for (let r = 0; r < results.length; r++) {
                const result = results[r];
                if (
                    result && result[ResultDataNew.Data.key]
                    && result[ResultDataNew.Data.key][DataSection.Tagging.key]
                ) {
                    if (!result[ResultDataNew.Data.key][DataSection.Tagging.key].pitch) {
                        continue;
                    }
                    if (!result[ResultDataNew.Data.key][DataSection.Scoring.key]) {
                        continue;
                    }

                    const outs = result[ResultDataNew.Data.key][DataSection.Scoring.key][ScoringData.Outs.key] || [];

                    // look for double and triple play in out structure
                    if (outs.some(o => o && this.multipleOutsClassifier(o[Out.Type.key]))) {
                        multiOutsActions.push(result);
                        continue;
                    }

                    const paResult = result[ResultDataNew.Data.key][DataSection.Scoring.key][ScoringData.PlateAppearanceResult.key];
                    // TODO - this is not possible when we have a batted ball, only when strikeout. Still can be useful for other stats - to do - remove later
                    // double play when batter is out. not always we can only rely on double play out type, for example "Strike 'Em Out, Throw 'Em Out" => https://www.youtube.com/watch?v=buddjkgJLAQ
                    if (
                        this.strikeoutClassifier(paResult) &&
                        // @see https://www.reddit.com/r/baseball/comments/4mwt5z/is_a_strike_em_out_throw_em_out_scored_as_a/
                        outs.some(o => o && o[Out.Type.key] === OutType.CaughtStealing.key)
                    ) {
                        multiOutsActions.push(result);
                        continue;
                    }

                    // batter out and other outs reported as on last play
                    if (
                        this.batterOutClassifier(paResult)
                        && outs.some(o => o && o[Out.Type.key] === OutType.OnLastPlay.key)
                    ) {
                        multiOutsActions.push(result);
                        continue;
                    }
                }
            }

            return multiOutsActions;
        }

        // games with tagging from old BBH goes here
        // TODO - in theory sometimes we could determine that, but still without type of out we are not sure what happened
        return results;
    }
}

export default ClassifiedAsMultipleOutsFilter;